import { createUseStyles } from 'react-jss';

import colors from "../../utils/colors";






var styles = {
  tableContainer: function tableContainer(_ref) {var columnsAmount = _ref.columnsAmount,showWideColumns = _ref.showWideColumns;return {
      maxWidth: '120rem',
      // each column width 34rem/40rem, first column with attributes names - 25
      width: showWideColumns ? "".concat(columnsAmount * 40 + 25, "rem") : "".concat(columnsAmount * 34 + 25, "rem"),
      overflow: 'auto',
      border: "1px solid ".concat(colors.neutral[300]),
      backgroundColor: colors.neutral.white,
      borderRadius: '1rem',
      margin: '0 auto'
    };},
  comparisonTable: {
    tableLayout: 'auto'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map